import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { DomElement } from "../../../../../library/ts/html/dom/DomElement";

export class ReminderModeIcon extends DomElement<HTMLElement>
{
  static type = new ElementType( "reminder-mode-icon" );
}